import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=8d34dd64&"
import script from "./pager.vue?vue&type=script&lang=js&"
export * from "./pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d34dd64')) {
      api.createRecord('8d34dd64', component.options)
    } else {
      api.reload('8d34dd64', component.options)
    }
    module.hot.accept("./pager.vue?vue&type=template&id=8d34dd64&", function () {
      api.rerender('8d34dd64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/news/pager.vue"
export default component.exports